const initDropAHint = () => {
  const closeBtns = document.querySelectorAll<HTMLElement>(
    "[data-drop-a-hint-close]"
  );
  const openBtns = document.querySelectorAll<HTMLElement>(
    "[data-drop-a-hint-open]"
  );

  const popup = document.getElementById("drop-a-hint");

  if (popup) {
    closeBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        popup.classList.remove("is-fixed", "is-visible", "active");
      });
    });

    openBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        popup.classList.add("is-fixed", "is-visible", "active");
      });
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  initDropAHint();
});
